// extracted by mini-css-extract-plugin
module.exports = {"smallButton":"UserIconButton_smallButton__2q7F7","bigButton":"UserIconButton_bigButton__Z0syv"};